import { Zap } from "lucide-react";

export default function CrystalBallHero() {
  return (
    <section className="relative overflow-hidden py-16 md:py-24 px-6">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-[hsl(262,80%,15%)] via-[hsl(240,50%,12%)] to-[hsl(220,40%,10%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,hsl(262,80%,60%,0.15),transparent_60%)]" />

      <div className="relative max-w-5xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-crystal-purple/30 bg-crystal-purple/10 mb-6">
          <Zap className="w-4 h-4 text-crystal-purple" />
          <span className="text-sm font-semibold text-crystal-purple tracking-wide uppercase">
            Predictive Quality Intelligence
          </span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-foreground mb-6 leading-tight">
          Quality Crystal Ball
          <span className="block text-transparent bg-clip-text bg-gradient-to-r from-crystal-purple to-crystal-blue">
            ⚡ Powered by Arqera AI
          </span>
        </h1>

        <p className="text-lg md:text-xl text-light-gray/80 max-w-3xl mx-auto mb-4">
          See defects before they happen. Our AI analyzes your production data in real-time
          to predict quality failures and prevent costly waste, saving manufacturers
          millions annually.
        </p>

        <p className="text-sm text-medium-gray max-w-2xl mx-auto">
          Upload your production data below to see a live prediction of defects
          for the next 7 days.
        </p>
      </div>
    </section>
  );
}
